const VideoWrapper = ({ children }) => {

  return <div className="relative mx-auto h-full w-full md:w-[calc(0.5625*100vh)]">
    {children}
  </div>

}

export default VideoWrapper
